// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-pages----RemotePage-module---wrapper---3UAKj"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/RemotePage.module.css
// module id = 638
// module chunks = 75563080901475